import React from 'react';
import { Card, CardContent, Typography, Box, Button } from '@mui/material';

const cardSx = {
    width: 360,
    height: 240,
};

const NotifyUsersCard: React.FC = () => {
    return (
        <Card sx={cardSx}>
            <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Notify all users</Typography>
                </Box>
            </CardContent>

            <CardContent>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        align="center"
                    >
                        Send email to all users
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ borderRadius: 20 }}
                    >
                        Create
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default NotifyUsersCard;
